export class FilterField{
    public index!: number;
    public name!: string;

}